"use client";
import { jsx as C, Fragment as l } from "react/jsx-runtime";
import { createSvgIcon as r } from "@mui/material/utils";
const L = r(
  /* @__PURE__ */ C(l, { children: /* @__PURE__ */ C(
    "path",
    {
      d: "M21.17 11.5201C21.66 11.0501 21.84 10.3501 21.63 9.71006C21.42 9.06006 20.87 8.59006 20.18 8.50006L15.82 7.88006C15.7 7.86006 15.6 7.79006 15.54 7.68006L13.59 3.79006C13.29 3.18006 12.67 2.81006 11.99 2.81006C11.31 2.81006 10.69 3.19006 10.39 3.79006L8.44 7.68006C8.39 7.79006 8.28 7.86006 8.16 7.88006L3.81 8.50006C3.13 8.60006 2.57 9.06006 2.36 9.71006C2.15 10.3601 2.33 11.0501 2.82 11.5201L5.97 14.5501C6.05 14.6301 6.09 14.7501 6.07 14.8601L5.33 19.1401C5.21 19.8001 5.48 20.4701 6.03 20.8701C6.58 21.2701 7.31 21.3301 7.92 21.0101L11.81 18.9901C11.92 18.9301 12.05 18.9301 12.16 18.9901L16.06 21.0101C16.32 21.1501 16.61 21.2101 16.89 21.2101C17.26 21.2101 17.63 21.0901 17.95 20.8601C18.5 20.4601 18.76 19.8001 18.65 19.1301L17.91 14.8501C17.89 14.7401 17.93 14.6201 18.01 14.5401L21.16 11.5101L21.17 11.5201Z",
      fill: "currentColor"
    }
  ) }),
  "KmxStarFullFilled"
);
export {
  L as default
};
